var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Divider from '@mui/material/Divider';
import { useTranslation } from 'react-i18next';
import { OGIconTooltip } from '@opengear/icon-tooltip';
import { useSearchParams } from 'react-router-dom';
import { PermissionsTable } from '../permissions/permissions-table';
import { DisabledTextField } from '../../inputs/disabled-text-field';
import { useFormatPermission } from '../utils';
import { GroupLinks, QUERY_PARAM_GROUPNAME_KEY } from '../groups/group-links';
import GroupModal from '../groups/group-modal';
export function RoleReadonlyForm(_a) {
    var role = _a.role;
    var t = useTranslation().t;
    var formatPermission = useFormatPermission();
    var _b = __read(useSearchParams(), 2), searchParams = _b[0], setSearchParams = _b[1];
    var modalOpen = useMemo(function () { return !!searchParams.get(QUERY_PARAM_GROUPNAME_KEY); }, [searchParams]);
    var handleModalClose = function () {
        searchParams.delete(QUERY_PARAM_GROUPNAME_KEY);
        setSearchParams(searchParams);
    };
    var modalGroupName = searchParams.get(QUERY_PARAM_GROUPNAME_KEY) ? searchParams.get(QUERY_PARAM_GROUPNAME_KEY) : undefined;
    return (_jsxs(_Fragment, { children: [modalGroupName && _jsx(GroupModal, { groupName: modalGroupName, open: modalOpen, onClose: handleModalClose }), _jsxs(Stack, __assign({ "aria-label": t('components.role.form.label'), component: "form", padding: 2, width: "100%" }, { children: [_jsx(DisabledTextField, { id: "rolename", label: t('components.role.form.fields.name.label'), value: role.rolename }), role.description && _jsx(DisabledTextField, { id: "description", label: t('components.role.form.fields.description.label'), value: role.description }), role.groups.length > 0 && (_jsxs(FormControl, { children: [_jsx(InputLabel, { children: t('components.role.form.fields.groups.label') }), _jsx(GroupLinks, { groups: role.groups })] })), _jsx(Divider, { sx: { marginX: -2, marginBottom: 2 } }), _jsx(Typography, __assign({ component: "h3", gutterBottom: true, variant: "h3" }, { children: t('components.permissions.form.title') })), _jsx(DisabledTextField, { id: "console-shell", label: _jsxs(_Fragment, { children: [t('components.permissions.form.fields.console_shell.label'), _jsx(OGIconTooltip, { title: t('components.permissions.form.fields.console_shell.tooltip') })] }), value: formatPermission(role.permissions.cli.console_shell) }), role.permissions.cli.shell_access && (_jsx(DisabledTextField, { id: "shell-access", label: _jsxs(_Fragment, { children: [t('components.permissions.form.fields.shell_access.label'), _jsx(OGIconTooltip, { title: t('components.permissions.form.fields.shell_access.tooltip') })] }), value: formatPermission(role.permissions.cli.shell_access) })), _jsx(DisabledTextField, { id: "pm-shell", label: _jsxs(_Fragment, { children: [t('components.permissions.form.fields.pm_shell.label'), _jsx(OGIconTooltip, { title: t('components.permissions.form.fields.pm_shell.tooltip') })] }), value: formatPermission(role.permissions.cli.pm_shell) }), _jsx(Divider, { sx: { marginX: -2, marginBottom: 2 } }), _jsx(PermissionsTable, { permissions: role.permissions })] }))] }));
}
